import { render, staticRenderFns } from "./TaxonomyTree.vue?vue&type=template&id=507c1547&"
import script from "./TaxonomyTree.vue?vue&type=script&lang=ts&"
export * from "./TaxonomyTree.vue?vue&type=script&lang=ts&"
import style0 from "./TaxonomyTree.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VTreeview } from 'vuetify/lib/components/VTreeview';
installComponents(component, {VBadge,VTreeview})
